import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { Container, Row, Col } from 'reactstrap';
import AnimateCC from "react-adobe-animate";




const onclickgamelink = () => {
  window.open('https://play.google.com/store/apps/details?id=com.Pranzzz.Buggeyfrog');
}

const Gamedisplay = (props) => {
  const useStyles = makeStyles({
    root: {
      maxWidth: 400,
    },
    media: {
      height: 340,
    },
  });
  const classes = useStyles();
  const [, setAnimationObject] = useState(null);
  const getAnimationObject = obj => setAnimationObject(obj);

  return (
    <Container className="mt-5" style={{position:'-webkit-sticky',zIndex:-100}} >
      <Row   >
        <Col>
          <Card className={classes.root}>
            <CardActionArea>
              <CardMedia
                className={classes.media}
                title="Contemplative Reptile"

              >    <AnimateCC
              animationName={props.animationName}
              getAnimationObject={getAnimationObject}
           
            />
                </CardMedia>
              <CardContent>
                <Typography gutterBottom variant="h5" component="h2">
                 {props.titlename}
          </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                  {props.content}
          </Typography>
              </CardContent>
            </CardActionArea>
            <CardActions>
              <Button size="medium" color="primary" onClick={onclickgamelink}>
                {props.download}
        </Button>

            </CardActions>
          </Card>
          
      
         
        </Col>
      </Row>
    </Container>
  );
}
export default Gamedisplay